import { DefaultUrlSerializer, UrlTree } from '@angular/router';


 export class LowerCaseAdminUrlSerializer extends DefaultUrlSerializer {
   parse(url: string): UrlTree {
      if (url.toLowerCase().includes('admin')) {
        return super.parse(url.toLowerCase());
      } else {
        return super.parse(url);
      }
  }
}
